import React from 'react';
import { Hero } from '../components/Hero';
import { SocialProof } from '../components/SocialProof';
import { ProductSuite } from '../components/ProductSuite';
import { PersonaTabs } from '../components/PersonaTabs';
import { UseCases } from '../components/UseCases';
import { HowItWorks } from '../components/HowItWorks';
import { PricingTeaser } from '../components/PricingTeaser';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <>
      <Hero data-id="element-415" />
      <SocialProof data-id="element-416" />
      <ProductSuite data-id="element-417" />
      <PersonaTabs data-id="element-418" />
      <UseCases data-id="element-419" />
      <HowItWorks data-id="element-420" />
      <PricingTeaser data-id="element-421" />
      <FinalCTA data-id="element-422" />
    </>;
}